/* product-first-flame-r13.js — presentation only. The money path (add to cart,
   availability, sold-out truth) belongs to pdp-atc.js and is not duplicated here.
   This file owns: the chosen-card class (an explicit .on, never :has(input:checked) —
   script-set state does not repaint :has() in headless/old Safari, found in round 11),
   the under-CTA note swap, the gallery thumb swap, and the two sticky bars.
   The desktop bar appears only once the panel has scrolled past the viewport top.
   The phone bar also stands in on load while the buy button is still below the
   fold (2026-09-23); both stand down whenever a buy button is on screen. */
(function () {
  var scope = document.querySelector('.ffr13');
  if (!scope) return;

  /* ---- panel state ---- */
  var packs = scope.querySelector('#packs');
  var note = scope.querySelector('[data-ffr13-note]');
  var pay = scope.querySelector('[data-ffr13-pay]');
  var barNotes = scope.querySelectorAll('[data-ffr13-bar-note]');

  function render() {
    if (!packs) return;
    var checked = packs.querySelector('input:checked');
    var mode = checked && checked.value === 'sub' ? 'sub' : 'once';
    packs.querySelectorAll('.pack').forEach(function (p) {
      var input = p.querySelector('input');
      p.classList.toggle('on', !!(input && input.checked));
    });
    /* !== undefined, not truthiness: the once-state note is deliberately the
       empty string, and a truthy check would leave the sub note stuck on
       screen after switching back. */
    if (note && note.dataset[mode] !== undefined) note.textContent = note.dataset[mode];
    /* The marks are real SVGs now, so the state toggles a class instead of
       rewriting text — writing textContent here would erase the whole row. */
    if (pay) pay.classList.toggle('cards-only', mode === 'sub');
    barNotes.forEach(function (el) { if (el.dataset[mode] !== undefined) el.textContent = el.dataset[mode]; });
  }
  if (packs) packs.addEventListener('change', render);
  render();

  /* ---- gallery ------------------------------------------------------------
     Restores what the shared pdp-gallery.js gives every other PDP and this page
     had lost: the new frame is decoded BEFORE it is shown and cross-fades in,
     so a swap never flashes a half-painted image; the main frame answers a
     swipe and the arrow keys; the neighbouring frame is warmed so the next
     swap is instant; and a frame that fails to load retries twice instead of
     leaving a blank rectangle. A reader who has asked for less motion gets the
     swap with no fade at all. ------------------------------------------------ */
  var main = scope.querySelector('[data-ffr13-main]');
  var counter = scope.querySelector('[data-ffr13-counter]');
  var thumbs = [].slice.call(scope.querySelectorAll('[data-ffr13-thumb]'));
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── THE POSITION RAIL ────────────────────────────────────────────────────
     The bundles drew their position as a pill on the photograph and their own
     text node; it is the tool gallery's rail now (snippets/pdp-gallery-rail),
     the same component and the same two elements the resin and tool scripts
     drive. Same contract as assets/product-hero.js:railSet, deliberately. */
  var railCur = counter && counter.querySelector('[data-rail-current]');
  var railFill = counter && counter.querySelector('[data-rail-fill]');
  var railLive = counter && counter.querySelector('[data-rail-live]');
  var railTotal = counter ? (+counter.getAttribute('data-gallery-count') || thumbs.length) : thumbs.length;
  var railTimer = null;

  function railSet(i) {
    if (!counter || railTotal < 2) return;
    var n = i + 1;
    if (n < 1) n = 1;
    if (n > railTotal) n = railTotal;
    if (railCur) railCur.textContent = n < 10 ? '0' + n : String(n);
    if (railFill) railFill.style.transform = 'translateX(' + ((n - 1) * 100) + '%)';
    if (railLive) {
      clearTimeout(railTimer);
      railTimer = setTimeout(function () {
        var t = counter.getAttribute('data-gallery-announce') || 'Image {index} of {total}';
        railLive.textContent = t.replace('{index}', String(n)).replace('{total}', String(railTotal));
      }, 350);
    }
  }
  var cur = 0;

  /* A frame that 404s or races the CDN leaves an empty box. Two retries, backing
     off, then give up and let the alt text carry it. */
  function guard(img) {
    if (!img || img.__g) return;
    img.__g = 1;
    img.addEventListener('error', function () {
      var r = +(img.getAttribute('data-gr') || 0);
      if (r >= 2) { img.style.opacity = ''; return; }
      img.setAttribute('data-gr', r + 1);
      var s = img.src; img.removeAttribute('src');
      setTimeout(function () { img.src = s; }, 260 * (r + 1));
    });
    img.addEventListener('load', function () {
      img.style.opacity = ''; img.removeAttribute('data-gr');
    });
  }
  guard(main);

  /* Warm the neighbours so a swipe or a click lands on a decoded image.

     GALLERY_SIZES must stay byte-identical to snippets/pdp-gallery.liquid's
     g_sizes and to the five sections' own `sizes`. A bare `new Image()` with a
     srcset and NO sizes defaults to 100vw, which resolves to a different rung
     than the element does: measured on a 1440x900 DPR-1 desktop the element
     took 780w (99,232 B) and this warmed 1066w (285,528 B), so the click then
     downloaded the frame a SECOND time. 285 KB spent to save nothing. */
  var GALLERY_SIZES = '(max-width: 749px) 260px, 533px';

  function warmOne(k) {
    var b = thumbs[k]; if (!b || b.__w) return null; b.__w = 1;
    var im = new Image();
    if (b.getAttribute('data-full-srcset')) {
      im.sizes = GALLERY_SIZES;
      im.srcset = b.getAttribute('data-full-srcset');
    }
    im.src = b.getAttribute('data-full');
    return im;
  }
  function warm(i) { warmOne(i - 1); warmOne(i + 1); }

  /* FRAME TWO EARLY, WITHOUT HOLDING WINDOW LOAD (2026-10-31). A detached
     new Image() is a document image fetch: Chromium and Firefox hold window
     `load` until it lands. Started at the hero's load (#3522) it pushed `load`
     on the-sanctum from 5.7 s to 8.5 s (Chromium, 4x CPU, 1.6 Mbps / 150 ms),
     and snippets/gtm-loader starts the tags at `load` for a visitor who has
     not touched the page. A <link rel=preload as=image> is fetched with the
     same Accept header as the <img> (Shopify's CDN varies on it, so a plain
     fetch() came back as a JPEG and was fetched again by the image), does not
     hold `load` in Chromium, Firefox or WebKit, and the Image the tap or the
     load-time warm creates is served from it with no second request (hermetic,
     tests/browser/gallery-warm-keeps-load-proof.mjs). Same srcset and sizes as
     warmOne(), so it picks the same rung. Skipped where the browser cannot
     preload by srcset: there it would fetch data-full, the wrong rung. */
  function early(k) {
    var b = thumbs[k]; if (!b || b.__w || b.__e) return;
    var l = document.createElement('link'), ss = b.getAttribute('data-full-srcset');
    if (!(l.relList && l.relList.supports && l.relList.supports('preload'))) return;
    if (ss && !('imageSrcset' in l)) return;
    b.__e = 1;
    l.rel = 'preload'; l.as = 'image'; l.setAttribute('fetchpriority', 'low');
    if (ss) { l.setAttribute('imagesrcset', ss); l.setAttribute('imagesizes', GALLERY_SIZES); }
    l.href = b.getAttribute('data-full');
    document.head.appendChild(l);
  }

  /* EVERY FRAME, NOT JUST THE FIRST TWO. `warm(i)` reaches i-1 and i+1, so the
     single warm(0) below left frames 2 and 3 of a four-frame kit cold. Tapping
     through to them fetched a full-size image ON THE TAP: the reader sees the
     old photograph, then a swap when the download lands, which reads as the
     gallery starting from nothing every time. Sho: "why bundle gallery loads
     from zero everytime not as smooth".

     Walked one frame at a time, after window load: the next frame is asked for
     only once the last one has landed and the page has had an idle moment.
     The old walk called warm(k) (two frames) per idle callback with a 2.5 s
     timeout, so on a phone all six frames of a bundle (~500 KB) went out within
     ~300 ms of each other, one burst on the one pipe. warmOne() skips any
     frame already warmed, so this cannot double-fetch and it is safe to call
     after a warm(0) or a warm(i) has already run. */
  var _warmAt = 0;
  function warmRest() {
    var im = null;
    while (!im && _warmAt < thumbs.length) im = warmOne(_warmAt++);
    if (!im || _warmAt >= thumbs.length) return;
    var next = function () {
      im.onload = im.onerror = null;
      ('requestIdleCallback' in window) ? requestIdleCallback(warmRest, { timeout: 2500 })
                                        : setTimeout(warmRest, 600);
    };
    if (im.complete) next(); else { im.onload = next; im.onerror = next; }
  }

  /* Each tap is acknowledged at once and the photograph follows.

     The old shape gated everything on the full-size decode: while `busy`, a
     tap only queued its index and cur did not move until the commit, so quick
     taps on a slow connection collapsed into one step and read as rage clicks
     (the same defect PostHog replays showed on the r45 galleries, 6 Sep).
     Now the index, the counter, the marked thumbnail and the edge state
     advance on the tap itself; the image swaps when its decode lands, or
     after SWAP_GRACE_MS without waiting, whichever is first. Only the newest
     request may swap; a stale decode arriving late is ignored. */
  var SWAP_GRACE_MS = 350;
  var seq = 0;
  var lastPre = null;
  /* A superseded request must stop downloading, or quick taps on a slow
     connection leave several full-size fetches sharing the one pipe the newest
     frame needs. Emptying src on the abandoned Image releases it. */
  function dropPre(pre) {
    if (!pre) return;
    try { pre.onload = pre.onerror = null; pre.srcset = ''; pre.src = ''; } catch (e) {}
  }
  function show(i) {
    var btn = thumbs[i];
    if (!main || !btn) return;
    if (i === cur) return;
    var src = btn.getAttribute('data-full');
    if (!src) return;
    cur = i;
    thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    railSet(i);
    edge();
    /* A dissolve the previous tap started must not leave the frame dark: that
       request is superseded here and will never restore the opacity itself. */
    main.style.opacity = '';
    var mine = ++seq;
    var done = false;

    function commit() {
      if (done || mine !== seq) return;
      done = true;
      clearTimeout(grace);
      if (lastPre === pre) lastPre = null;
      /* srcset BEFORE src (2026-11-01). WebKit picks and starts the fetch on
         each assignment, not at the end of the task as Chromium does. With src
         first, after the thumbnail path below had removed the srcset, an
         iPhone fetched data-full -- the TOP rung, 1066w, ~256 KB on
         the-sanctum -- and the srcset a statement later picked 780w, the rung
         the warm already held: every early Next downloaded frame two twice.
         The element's own sizes is GALLERY_SIZES in all five sections, so
         this picks the rung warmOne() and early() warmed. A frame with no
         srcset must not inherit the last frame's (or the thumbnail's). */
      var ss = btn.getAttribute('data-full-srcset');
      if (ss) main.srcset = ss; else main.removeAttribute('srcset');
      main.src = src;
      var alt = btn.getAttribute('data-full-alt'); if (alt) main.alt = alt;
      main.loading = 'eager';            /* user-initiated; never let lazy defer it */
      main.style.opacity = '';
    }

    dropPre(lastPre);
    var pre = new Image();
    lastPre = pre;
    if (btn.getAttribute('data-full-srcset')) {
      pre.sizes = GALLERY_SIZES;
      pre.srcset = btn.getAttribute('data-full-srcset');
    }
    pre.src = src;
    /* SOMETHING ON SCREEN AT THE TAP (2026-10-30), as product-hero-r45.js and
       pdp-gallery.js already do: if the frame is not in hand, the tapped
       thumbnail -- on screen, so already decoded -- goes up in the photo box at
       once and the full frame replaces it when it lands. Without it a cold
       frame left the old photograph up for the whole download while the rail
       had already moved on, which is what a rage click is. */
    if (!(pre.complete && pre.naturalWidth)) {
      var ti = btn.querySelector('img');
      /* The thumbnail as the ONE srcset candidate, then as src (2026-11-01).
         Removing the srcset first left WebKit with the old src alone for a
         moment, and it fetched the frame on screen again at its top rung
         (1066w) only to throw it away; src first with the old srcset still
         there made Chromium pick the frame on screen once more. This way each
         engine only ever picks the thumbnail, which is already decoded. A
         serialised URL has no whitespace, so it is a valid srcset by itself. */
      if (ti && ti.complete && ti.naturalWidth) { var tu = ti.currentSrc || ti.src; main.srcset = tu; main.src = tu; }
    }

    function ready() {
      if (done || mine !== seq) return;
      /* The decode landed inside the grace window: the dissolve now owns the
         ending, so the grace path must not cut it half way. */
      clearTimeout(grace);
      /* Neighbours warm only now, once this frame has actually landed: warming
         on the tap or on the grace path adds two fetches to the very pipe that
         is still carrying this frame. */
      warm(i);
      if (still) return commit();
      main.style.opacity = '0';
      function fire() { commit(); }
      main.addEventListener('transitionend', function h(e) {
        if (e.propertyName !== 'opacity') return;
        main.removeEventListener('transitionend', h); fire();
      });
      setTimeout(fire, 260);             /* transitionend can be skipped; never hang */
    }
    var grace = setTimeout(function () { if (!done && mine === seq) { main.style.opacity = ''; commit(); } }, SWAP_GRACE_MS);
    if (pre.decode) pre.decode().then(ready).catch(ready); else if (pre.complete) ready();
    else { pre.onload = ready; pre.onerror = ready; }
  }

  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { show(i); });
    btn.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var n = e.key === 'ArrowRight' ? i + 1 : i - 1;
      if (n < 0 || n >= thumbs.length) return;      /* no wrap, as live */
      thumbs[n].focus(); show(n);
    });
  });

  /* Swipe the frame itself. Horizontal intent only, so a vertical scroll that
     starts on the picture still scrolls the page. */
  if (main && thumbs.length > 1) {
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY;
      warm(cur);
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      var n = dx < 0 ? cur + 1 : cur - 1;
      if (n < 0 || n >= thumbs.length) return;      /* no wrap, as live */
      show(n);
    }, { passive: true });
  }
  /* Not on a metered connection. Warming slide 2 is 285 KB on First Flame,
     316 on the Three Kings, 293 on the Alchemist — more than the hero — for a
     frame the reader may never open. bundle-ritual-films.js makes the same
     refusal for the same reason. */
  var metered = !!(typeof navigator !== 'undefined' && navigator.connection && navigator.connection.saveData === true);
  /* Two moments (2026-10-31).
     - The hero frame has landed: frame two only, by early() above, so a Next
       pressed in the seconds before window load finds it warm. Never while
       the hero is still downloading (it would ride against the LCP image).
     - Window load: the Image for frame two (served from that preload), then
       warmRest() walks the rest one at a time. Not behind an idle callback:
       requestIdleCallback with no timeout never fired while a throttled phone
       was still booting tags, and a Next pressed two seconds after load found
       frame two cold and took 3.6 s (Chromium, 4x CPU, 1.6 Mbps / 150 ms,
       the-sanctum). Once only: show() reassigns main.src later. */
  var warmFirst = function () {
    if (metered) return;
    /* Never the frame on screen: its bytes are already painted. Walking it
       re-requested the hero, 216 KB on the-sanctum, at the head of the queue
       (live trace, 2026-10-31). */
    if (thumbs[0]) thumbs[0].__w = 1;          /* the frame the server drew */
    if (thumbs[cur]) thumbs[cur].__w = 1;
    /* Frame two first (usually already in hand from early()), and the walk
       only once it has landed, so the two never share the pipe. */
    warmOne(cur - 1);
    var f = warmOne(cur + 1);
    if (f && !f.complete) f.onload = f.onerror = function () { f.onload = f.onerror = null; warmRest(); };
    else warmRest();
  };
  /* Not once a tap has been made (seq > 0): show() warms the neighbours of the
     frame asked for, once it has landed, as r45 and pdp-gallery hold theirs. */
  var heroIn = function () { if (!metered && seq === 0 && document.readyState !== 'complete') early(cur + 1); };
  if (document.readyState === 'complete') setTimeout(warmFirst, 0);
  else {
    addEventListener('load', function () { setTimeout(warmFirst, 0); }, { once: true });
    if (main && main.complete && main.naturalWidth) heroIn();
    else if (main) main.addEventListener('load', heroIn, { once: true });
  }

  /* The arrows. They move one frame and stop at the ends — the shelf has an
     edge and the picture should say so rather than looping. `data-edge` lets
     CSS dim whichever arrow is exhausted. */
  var figure = scope.querySelector('.ffr13-photo');
  function edge() {
    if (!figure) return;
    figure.removeAttribute('data-edge');
    var atStart = cur <= 0, atEnd = cur >= thumbs.length - 1;
    if (prevBtn) { prevBtn.disabled = thumbs.length < 2 || atStart; prevBtn.setAttribute('aria-disabled', prevBtn.disabled ? 'true' : 'false'); }
    if (nextBtn) { nextBtn.disabled = thumbs.length < 2 || atEnd; nextBtn.setAttribute('aria-disabled', nextBtn.disabled ? 'true' : 'false'); }
    if (thumbs.length < 2) return;
    if (atStart) figure.setAttribute('data-edge', 'start');
    else if (atEnd) figure.setAttribute('data-edge', 'end');
  }
  var prevBtn = scope.querySelector('[data-ffr13-prev]');
  var nextBtn = scope.querySelector('[data-ffr13-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { if (cur > 0) show(cur - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { if (cur < thumbs.length - 1) show(cur + 1); });
  if (thumbs.length < 2 && prevBtn && nextBtn) { prevBtn.hidden = nextBtn.hidden = true; }
  edge();

  /* Honour a tap that arrived before this file did (2026-10-30).
     snippets/gallery-preboot-tap holds the last arrow or thumbnail press from
     parse time and shows it at once; the five bundle sections did not render
     it, so a press in the seconds before this deferred file ran was simply
     lost (the ffr13 dead clicks in PostHog). After every gallery listener
     above, never before: drained first, the replay lands on a button with no
     handler yet. */
  if (typeof window.__ssGalleryDrain === 'function') window.__ssGalleryDrain();

  /* ---- the questions open and close, they do not snap ---------------------
     A bare <details> jumps to its full height and jumps back. The browser hides
     the content the instant `open` is removed, so a closing animation needs the
     panel kept alive for the duration — hence the shim. Height is measured, not
     guessed, so a two-line answer and a six-line answer both take the same
     easing. Anyone who has asked for less motion gets the native behaviour. ---- */
  var faqs = [].slice.call(scope.querySelectorAll('.ffr13-faq details'));
  if (faqs.length && !still) {
    faqs.forEach(function (d) {
      var sum = d.querySelector('summary');
      var body = d.querySelector('p');
      if (!sum || !body) return;
      var moving = false;

      function sweep(to, after) {
        moving = true;
        var from = to === 0 ? body.scrollHeight : 0;
        body.style.overflow = 'hidden';
        body.style.height = from + 'px';
        body.style.opacity = to === 0 ? '1' : '0';
        /* force layout so the browser has a start value to animate from */
        void body.offsetHeight;
        body.style.transition = 'height .26s var(--ff-ease, cubic-bezier(.16,1,.3,1)), opacity .2s ease';
        body.style.height = (to === 0 ? 0 : body.scrollHeight) + 'px';
        body.style.opacity = to === 0 ? '0' : '1';
        var done = false;
        function end() {
          if (done) return; done = true;
          body.style.transition = body.style.height = body.style.overflow = body.style.opacity = '';
          moving = false;
          if (after) after();
        }
        body.addEventListener('transitionend', function h(e) {
          if (e.propertyName !== 'height') return;
          body.removeEventListener('transitionend', h); end();
        });
        setTimeout(end, 420);
      }

      /* THIS HANDLER OWNS THE TOGGLE IN BOTH DIRECTIONS, and the missing
         preventDefault on the opening branch is why none of these five ever
         opened. Clicking a <summary> toggles `open` as the browser's own
         default action, AFTER the listener has run. The opening branch set
         `d.open = true` and then let the default fire, which toggled it
         straight back to false — so every question below the first was dead to
         a click and to the keyboard, at every width, since the animation
         landed. Prevent the default every time and set `open` ourselves. */
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (moving) return;
        if (d.open) {
          sweep(0, function () { d.open = false; });
        } else {
          d.open = true;
          sweep(1);
        }
      });
    });
  }

  /* ── sticky surfaces ───────────────────────────────────────────────────────
     Both bars appear once the buy panel has left through the TOP of the
     viewport, and at no other time.

     WHY THIS IS NOT AN INTERSECTION OBSERVER ANY MORE.
     It was, with `threshold: 0`, and a threshold only fires a callback when the
     intersection RATIO crosses it. An element that goes from below the fold to
     above it without ever being drawn stays at ratio 0 the whole way, so no
     callback fires and the bar never arrives. Measured on the preview, all five
     bundle pages: stepping down 600px at a time showed the bar from y=1800;
     jumping straight to y=3000 left it parked off-screen at translateY(79px)
     with the element live and `display: flex`. Every anchor jump (#reviews),
     deep link, bfcache restore and End key landed in that state.

     This is the same fault, and the same cure, as assets/product-hero-r45.js
     lines 456-582, which stopped using an observer for this question in
     August. A passive scroll listener coalesced into one requestAnimationFrame
     is the honest instrument for a question about scroll position: it costs one
     getBoundingClientRect per painted frame while the finger is down, it cannot
     miss a state, and `passive: true` keeps it off the scrolling thread.

     The geometry test is `bottom < 0`, not `top < 0`, so the bar waits until the
     whole panel has gone rather than sliding in over a CTA still on screen. */
  var panel = scope.querySelector('#ffr13-panel');
  var buybar = document.getElementById('ffr13-buybar');
  var mobilebar = document.getElementById('ffr13-mobilebar');
  /* Four of the five bundle closes still carry a second buy surface
     (#sec-offer); First Flame's was removed on 2026-09-12. A sticky bar that
     hovers over an add-to-cart already on screen is noise, so both bars stand
     down while that offer is in view. The old observer expressed "in view" as
     threshold 0.18; the same figure is computed here from the rectangle, for
     the same reason the panel test is - a threshold cannot be trusted to fire. */
  var offer = document.getElementById('sec-offer');
  if (panel && (buybar || mobilebar)) {
    var shown = null, wide = null, shownMobile = null, ticking = false;

    function offerInView() {
      if (!offer) return false;
      var r = offer.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (visible <= 0) return false;
      /* ratio against whichever is smaller, so an offer taller than the screen
         still counts as "in view" once it fills enough of it */
      return visible / Math.min(r.height, vh) >= 0.18;
    }

    /* `showMobile` (2026-09-23): the phone bar also stands in while the buy
       button has not yet come up from below the fold. The desktop bar keeps the
       panel-gone rule. On a phone the bundle button sits ~1,600px down and paid
       shoppers arrive in the Instagram/Facebook browser at a median 750px
       viewport, so the first screen had a photograph and nothing to press
       (PostHog 9-23 Sep: 15% of paid Trinity and 24% of paid First Flame visits
       ended before the button came into view). Same rule the oil pages' bar has
       used for weeks; it still stands down whenever the button or the offer is
       on screen. */
    function paint(show, w, showMobile) {
      /* never touch the DOM for nothing: this runs once per painted frame */
      if (show === shown && w === wide && showMobile === shownMobile) return;
      shown = show; wide = w; shownMobile = showMobile;
      if (buybar) {
        buybar.classList.toggle('show', show && w >= 990);
        var bb = buybar.querySelector('button');
        if (bb) bb.tabIndex = (show && w >= 990) ? 0 : -1;
      }
      if (mobilebar) {
        var on = showMobile && w <= 989;
        mobilebar.classList.toggle('show', on);
        mobilebar.setAttribute('aria-hidden', on ? 'false' : 'true');
        /* the bars are translated off-screen, not removed, so their buttons stay
           focusable while invisible unless they are taken out of the tab order */
        var mb = mobilebar.querySelector('button');
        if (mb) mb.tabIndex = on ? 0 : -1;
      }
    }

    function sync() {
      ticking = false;
      var gone = panel.getBoundingClientRect().bottom < 0;
      var offerOn = offerInView();
      var atc = scope.querySelector('#atc');
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var mbBtn = mobilebar && mobilebar.querySelector('button');
      var below = !!atc && atc.getBoundingClientRect().top >= vh && !(mbBtn && mbBtn.disabled);
      paint(gone && !offerOn, window.innerWidth, (gone || below) && !offerOn);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }

    sync();
    addEventListener('scroll', onScroll, { passive: true });
    /* a rotation with no scroll still changes which bar belongs on screen */
    addEventListener('resize', onScroll, { passive: true });
    /* a back-navigation restores the scroll position after the parser has run,
       so the state has to be taken again once the page is shown */
    addEventListener('pageshow', sync);
    /* Two re-reads with no scroll behind them (review, 2026-09-23): a pack switch
       that greys or frees the bar's button while the real one is still below the
       fold, and the layout settling once fonts, images and the in-app toolbar
       have landed. Without them the bar kept its last state until the next scroll. */
    var barAdd = mobilebar && mobilebar.querySelector('button');
    if (barAdd) new MutationObserver(onScroll).observe(barAdd, { attributes: true, attributeFilter: ['disabled'] });
    addEventListener('load', onScroll);
  }
  /* bar CTAs ride the shared money path; [data-sticky-add] (the mobile bar) is
     already bound and availability-painted by pdp-atc.js — only the desktop bar
     needs its own binding. */
  var barBtn = buybar && buybar.querySelector('[data-ffr13-bar-add]');
  if (barBtn) barBtn.addEventListener('click', function () {
    var checked = packs && packs.querySelector('input:checked');
    var vid = checked && checked.getAttribute('data-vid');
    if (vid && window.SacrasoulPdpAdd) window.SacrasoulPdpAdd(vid);
  });
})();

/* ── ROUND 40 · the deep questions, for a browser without ::details-content ──
   The six questions below the maker band are <details>, closed but for the
   first, and CSS opens them all again at 901 so a desktop reader meets the
   answers on the page. That reopening is `::details-content`, which every
   current engine has and an older one does not. Where it is missing, and only
   there, open them here instead. The phone never enters this branch, so it
   never pays a layout shift for it. */
(function questionsOpenOnWide() {
  var supported = false;
  try { supported = window.CSS && CSS.supports && CSS.supports('selector(::details-content)'); } catch (e) {}
  if (supported) return;
  if (!window.matchMedia || !window.matchMedia('(min-width: 901px)').matches) return;
  var list = document.querySelectorAll('.ff28-q details.qa');
  for (var i = 0; i < list.length; i++) list[i].open = true;
})();
